// Webpack Imports
import * as bootstrap from 'bootstrap';
	
	jQuery( document ).on( 'click','.search_lupa', function(e) {
		setTimeout(function(){ jQuery( 'body' ).attr( 'style', 'overflow: hidden !important;' ) }, 300);
	});
	
	jQuery( document ).on( 'click','.modal-body .lupa_wrapper', function(e) {
		console.log('a');
		jQuery( '#searchform' ).submit();
	});
	
	if ( jQuery( '.page-template-page-human-development' ).length > 0 ) {
		jQuery( document ).on( 'click', '.accordion-button', function(e) {
			const new_image = jQuery( this ).data( 'image' );
			jQuery( '.accordion_wrapper .background-image' ).css( 'background-image', 'url(' + new_image + ')' ).hide().fadeIn( 'slow' );
		});
	}
	
	if ( jQuery( '.home' ).length > 0 || jQuery( '.page-template-page-quem-somos' ).length > 0 ) {
		jQuery( document ).on( 'click', '.accordion-button', function(e) {
			const new_image = jQuery( this ).data( 'image' );
			jQuery( '.accordion_wrapper .background-image' ).css( 'background-image', 'url(' + new_image + ')' ).hide().fadeIn( 'slow' );
		});
	}
	
	if ( jQuery( '.page-template-page-candidatos' ).length > 0 ) {
		jQuery( document ).on( 'click', '.filtrar_btt', function(e) {
			e.preventDefault();
			const regiao = jQuery( 'select[name="regiao"]' ).val();
			const setor = jQuery( 'select[name="setor"]' ).val();
			const search = jQuery( 'input[name="search"]' ).val();
			
			window.location = window.location.href.split('?')[0] + '?regiao=' + encodeURIComponent(regiao) + '&setor=' + encodeURIComponent(setor) + '&search=' + search;
		});
		
		jQuery( document ).on( 'click', '.limpar_filtros', function(e) {
			e.preventDefault();
			window.location = window.location.href.split('?')[0];
		});
		
	}

	if ( jQuery( '.page-template-page-quem-somos' ).length > 0 ) {
		var odometer_clientes = new Odometer({
			el: jQuery( '.odometer_clientes' )[0],
			theme: 'minimal',
			duration: 3000,
			format: '',
		});
		
		odometer_clientes.render();
		jQuery( '.odometer_clientes' ).text( jQuery( '.odometer_clientes' ).data( 'number' ) );
		
		var odometer_faturacao = new Odometer({
			el: jQuery( '.odometer_faturacao' )[0],
			theme: 'minimal',
			duration: 3000,
			format: '',
		});
		
		odometer_faturacao.render();
		jQuery( '.odometer_faturacao' ).text( jQuery( '.odometer_faturacao' ).data( 'number' ) );
		
		var odometer_talentos = new Odometer({
			el: jQuery( '.odometer_talentos' )[0],
			theme: 'minimal',
			duration: 3000,
			format: '',
		});
		
		odometer_talentos.render();
		jQuery( '.odometer_talentos' ).text( jQuery( '.odometer_talentos' ).data( 'number' ) );
		
		var odometer_colaboradores = new Odometer({
			el: jQuery( '.odometer_colaboradores' )[0],
			theme: 'minimal',
			duration: 3000,
			format: '',
		});
		
		odometer_colaboradores.render();
		jQuery( '.odometer_colaboradores' ).text( jQuery( '.odometer_colaboradores' ).data( 'number' ) );
	}

	// TODO: To increase all numbers independently
	// TODO: Randomize fadeIn of different digits
	
	const timeline = document.querySelectorAll(".timeline");
	
	timeline.forEach((item) => {
		const timeline_texto = item.querySelector(".timeline-panel");
		const timeline_img = item.querySelector(".img-timeline");
	
		if ( timeline_texto && timeline_img ) {
			timeline_img.style.height = timeline_texto.offsetHeight + "px";
		}
	});
async function sharePost(title,text,url){

}
( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );
	
	if ( jQuery('.responsive-home').length > 0 ) {
		jQuery('.responsive-home').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
			  {
				breakpoint: 1024,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1,
				  infinite: true,
				  dots: true
				}
			  },
			  {
				breakpoint: 600,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 480,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  }
			  // You can unslick at a given breakpoint now by adding:
			  // settings: "unslick"
			  // instead of a settings object
			]
		  });
	}
	
	if ( jQuery('.responsive').length > 0 ) {
		jQuery('.responsive').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
			  {
				breakpoint: 1024,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 1,
				  infinite: true,
				  dots: true
				}
			  },
			  {
				breakpoint: 600,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 480,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  }
			  // You can unslick at a given breakpoint now by adding:
			  // settings: "unslick"
			  // instead of a settings object
			]
		  }).on("setPosition", function () {
			resizeSlider();
		});
	}
	
	jQuery(window).on("resize", function (e) {
	  resizeSlider();
	});
	
	var slickHeight =  jQuery(".first_div_news").height();
	
	function resizeSlider() {
	  jQuery(".slick-track")
		.find(".slick-slide .card.news_home")
		.css("height", slickHeight + "px");
	}
	
	if ( jQuery('.responsive-company').length > 0 ) {
		jQuery('.responsive-company').slick({
			dots: true,
			infinite: true,
			speed: 1000,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			responsive: [
			  {
				breakpoint: 1024,
				settings: {
				  slidesToShow: 4,
				  slidesToScroll: 1,
				  infinite: true,
				  dots: true
				}
			  },
			  {
				breakpoint: 600,
				settings: {
				  slidesToShow: 3,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 480,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 1
				}
			  }
			  // You can unslick at a given breakpoint now by adding:
			  // settings: "unslick"
			  // instead of a settings object
			]
		  });
	}

	if ( jQuery('.responsive-talent').length > 0 ) {
		jQuery('.responsive-talent').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
			  {
				breakpoint: 1024,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1,
				  infinite: true,
				  dots: true
				}
			  },
			  {
				breakpoint: 600,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 480,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  }
			  // You can unslick at a given breakpoint now by adding:
			  // settings: "unslick"
			  // instead of a settings object
			]
		  });
	}
	if ( jQuery('.responsive-consulting').length > 0 ) {
		jQuery('.responsive-consulting').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
			  {
				breakpoint: 1024,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1,
				  infinite: true,
				  dots: true
				}
			  },
			  {
				breakpoint: 600,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 480,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  }
			  // You can unslick at a given breakpoint now by adding:
			  // settings: "unslick"
			  // instead of a settings object
			]
		  });
	}
	
	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	jQuery(window).on('scroll',function() {
		if (jQuery(window).scrollTop() >= 101 || jQuery(window).width() <= 599) { 
			jQuery("header").addClass("active");
		} else {
			jQuery("header").removeClass("active");
		}
	});
	
	var ValidateEmail = function(mail) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			return true;
		}
		return false;
	}

	function checkLoadMoreBlog(){
		var totalpage = parseInt(jQuery('#loadMoreBlog').attr( 'total-page' ));
		var paged = parseInt(jQuery('#loadMoreBlog').attr( 'data-page' ));
		if (paged >= totalpage) jQuery('#loadMoreBlog').hide();
	}

	jQuery( document ).ready(function() {
		
		jQuery( document ).on( 'click', '.btn-contact', function(e) {
			e.preventDefault();
			
			if ( ! jQuery('#contact-form #politica' ).is( ':checked' ) ) {
				Swal.fire({
					icon: 'error',
					title: 'Política de Privacidade',
					text: 'Para submeter a sua mensagem, terá que aceitar a nossa política de privacidade!',
				});
				return false;
			}
			
			var nome = jQuery( '#contact-form #nome' ).val();
			var email = jQuery( '#contact-form #email' ).val();
			var assunto = jQuery( '#contact-form #assunto' ).val();
			var mensagem = jQuery( '#contact-form #mensagem' ).val();
			var marketing = '';
			
			if ( email && ! ValidateEmail( email ) ) {
				Swal.fire({
					icon: 'error',
					title: 'Email inválido',
					text: 'Por favor, introduza um email válido, obrigado!',
				});
				return false;
			}
			
			if ( jQuery('#contact-form #dados_pessoais' ).is( ':checked' ) ) {
				marketing = '1';
			}
		
			if ( ! nome || ! email || ! assunto || ! mensagem ) {
				Swal.fire({
					icon: 'error',
					title: 'Preencha todos os campos',
					text: 'Por favor preencha todos os campos antes de efetuar a submissão da sua mensagem, obrigado!',
				});
				return false;
			}
		
			jQuery.ajax({
				url: egorjs.ajax_url,
				type: 'POST',
				data: {
					action: 'send_email',
					nome: nome,
					email: email,
					assunto: assunto,
					mensagem: mensagem,
					marketing: marketing,
				},
				success: function(response) {
					if ( response.success ) {
						Swal.fire({
							icon: 'success',
							title: 'Mensagem enviada',
							text: 'Obrigado pela sua mensagem, seremos breves a retornar o contacto!',
						});
						
						jQuery( '#contact-form #nome' ).val( '' );
						jQuery( '#contact-form #email' ).val( '' );
						jQuery( '#contact-form #assunto' ).val( '' );
						jQuery( '#contact-form #mensagem' ).val( '' );
					} else {
						Swal.fire({
							icon: 'error',
							title: 'Mensagem não enviada',
							text: 'Houve um erro ao enviar a sua mensagem. Tente novamente mais tarde, obrigado!',
						});
						return false;
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					// A chamada AJAX falhou
					console.log( 'Erro na requisição AJAX: ' + textStatus + ' - ' + errorThrown );
				}
			});
		});
		
		jQuery( document ).on( 'click', '.btn-outline-primary-ta', function(e) {
			var target = jQuery( this ).data( 'target' );
			var open = jQuery( '.' + target ).attr( 'data-open' );
			jQuery( '.btn-outline-primary-ta' ).html( 'Ver mais' );
			jQuery( '.processos_text' ).hide();
			jQuery( '.processos_text' ).attr( 'data-open', '0' );

			if ( open === '1' ) {
				jQuery( this ).html( 'Ver mais' );
				jQuery( '.' + target ).slideUp();
				jQuery( '.' + target ).attr( 'data-open', '0' );
			} else {
				jQuery( this ).html( 'Fechar' );
				jQuery( '.' + target ).slideDown();
				jQuery( '.' + target ).attr( 'data-open', '1' );
			}
		});


		jQuery( document ).on( 'click', '#loadMoreBlog', function(e) {

			var paged = jQuery( this ).attr( 'data-page' );
			paged = parseInt(paged) + 1;

			var urlParams = new URLSearchParams( window.location.search );
			// Obtém o valor da variável 'search'
			var searchValue = urlParams.get( 'search' );

			jQuery.ajax({
				url: egorjs.ajax_url,
				type: 'POST',
				data: {
					action: 'load_more_blog',
					paged: paged,
					search: searchValue,
				},
				success: function(response) {
					if ( response.success ) {
						jQuery( '#loadMoreBlog' ).attr( 'data-page', paged );
						jQuery( '#posts-container' ).append( response.data );
						checkLoadMoreBlog();
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					// A chamada AJAX falhou
					console.log( 'Erro na requisição AJAX: ' + textStatus + ' - ' + errorThrown );
				}
			});
		});

		jQuery( document ).on( 'click', '#sharePost', async function(e) {
			const shareData = {
				title: jQuery( this ).attr( 'data-title' ),
				text: jQuery( this ).attr( 'data-text' ),
				url: jQuery( this ).attr( 'data-url' )
			};
			try {
				await navigator.share(shareData);
			} catch (err) {
				console.log(`Error: ${err}`);
			}
		});

		if ( jQuery( '.page-template-page-blog-2024' ).length > 0 ) {
			checkLoadMoreBlog();
		}

		if ( jQuery( '.single-processo' ).length > 0 ) {
			var urlParams = new URLSearchParams( window.location.search );
			var submetida = urlParams.get( 'candidatura_submetida' );
			if ( submetida ) {
				Swal.fire({
					icon: 'success',
					title: 'Candidatura submetida',
					text: 'Recebemos a sua candidatura, obrigado pelo seu interesse!',
				});
			}
		}
		
		if ( jQuery( '.page-template-page-login' ).length > 0 ) {
			jQuery( document ).on( 'click', '.remember_password', function(e) {
				e.preventDefault();
				
				var email = jQuery( '#username' ).val();
				
				if ( ! email ) {
					jQuery( '.remember_password_wrapper' ).fadeIn();
				}
				
				window.location = window.location.href.split('?')[0] + '?remember_password=1&email=' + email;
			});
			
			jQuery( document ).on( 'click', '.btn-login', function(e) {
				e.preventDefault();
				var username = jQuery( '#username' ).val();
				var password = jQuery( '#password' ).val();
				
				window.swal.fire( {
					text: 'A efetuar login...',
					imageUrl: wp_bullhorn.gif,
					showConfirmButton: false,
					allowOutsideClick: false
				});
				
				jQuery.ajax({
					url: egorjs.ajax_url,
					type: 'POST',
					data: {
						action: 'login_user',
						username: username,
						password: password,
						nonce: egorjs.nonce,
					},
					success: function(response) {
						if ( response.success ) {
							window.location = wp_bullhorn.site_url + '/area-reservada';
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: 'Username ou password fornecidos, estão errados. Tente novamente!',
								footer: '<a href="mailto:contactoegor@egor.pt">Por favor contacte o administrador do site.</a>'
							})
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						// A chamada AJAX falhou
						console.log( 'Erro na requisição AJAX: ' + textStatus + ' - ' + errorThrown );
					}
				});
			});
		}
		
		if ( jQuery( '.page-template-page-human-development' ).length > 0 ) {
			// Replace image for the first option
			const first_image = jQuery( '.accordion-button' ).first().data( 'image' );
			jQuery( '.accordion_wrapper .background-image' ).css( 'background-image', 'url(' + first_image + ')' ).hide().fadeIn( 'slow' );
		}
		
		if ( jQuery( '.single-post' ).length > 0 ) {
			jQuery( document ).on( 'click', '.explorar_cats li', function(e) {
				var data = jQuery(e.target).data("term-id");
				
				// Create a form element
				const form = document.createElement('form');
				
				// Set the form attributes
				form.method = 'POST';
				form.action = window.location.origin + '/noticias';
				
				// Add form data as hidden input fields
				const categoria = document.createElement('input');
				categoria.type = 'hidden';
				categoria.name = 'categorias[]';
				categoria.value = data;
				form.appendChild( categoria );
				
				// Submit the form
				document.body.appendChild( form );
				form.submit();
			});
		}
		
		if ( jQuery( '.page-template-page-talent_acquisition' ).length > 0 ) {
			// Obter a div que queremos monitorar
			const div_grafico = document.querySelector( '.svg_graphic_ta' );

			// Adicionar um evento de scroll à janela
			window.addEventListener('scroll', function() {
				// Obter a posição da div na página
				const divTop = div_grafico.getBoundingClientRect().top;
				const divBottom = div_grafico.getBoundingClientRect().bottom;
				
				// Obter a posição do elemento na página
				const elementoTop = div_grafico.getBoundingClientRect().top;
				const elementoBottom = div_grafico.getBoundingClientRect().bottom;
			
				// Obter a posição do scroll da página
				const scrollPosition = window.innerHeight / 2 + window.scrollY;
				const windowHeight = window.innerHeight;
			
				// Verificar se a div está no meio da tela
				if (divTop <= scrollPosition && divBottom >= scrollPosition && divTop >= window.innerHeight / 2) {
					setTimeout(function(){ jQuery( '.st1.first' ).fadeIn() }, 200);
					setTimeout(function(){ jQuery( '.st1.second' ).fadeIn() }, 400);
					setTimeout(function(){ jQuery( '.st1.third' ).fadeIn() }, 600);
					setTimeout(function(){ jQuery( '.st2.first' ).fadeIn() }, 800);
					setTimeout(function(){ jQuery( '.st7' ).fadeIn() }, 1000);
					setTimeout(function(){ jQuery( '.st6' ).fadeIn() }, 1200);
					setTimeout(function(){ jQuery( '.st5' ).fadeIn() }, 1400);
					setTimeout(function(){ jQuery( '.st4' ).fadeIn() }, 1600);
					setTimeout(function(){ jQuery( '.st3' ).fadeIn() }, 1800);
					setTimeout(function(){ jQuery( '.st2.second' ).fadeIn() }, 2000);
				}
			
			});
		}
		
		if ( jQuery( '.page-template-page-missao-e-visao').length > 0 ) {
			setTimeout(function(){ jQuery( '.box__1' ).fadeIn() }, 200);
			setTimeout(function(){ jQuery( '.box__2' ).fadeIn() }, 400);
			setTimeout(function(){ jQuery( '.box__3' ).fadeIn() }, 600);
			setTimeout(function(){ jQuery( '.box__4' ).fadeIn() }, 800);
			setTimeout(function(){ jQuery( '.box__5' ).fadeIn() }, 1000);
			setTimeout(function(){ jQuery( '.box__6' ).fadeIn() }, 1200);
		}
		
		if ( jQuery( '.home').length > 0 ) {
			
			// Obter a div que queremos monitorar
			const div_grafico = document.querySelector( '.grafico_desktop-big' );
			
			setTimeout(function(){ jQuery( '.circle .st2' ).addClass( 'bgcolor' ) }, 200);
			setTimeout(function(){ jQuery( '.circle .st3' ).addClass( 'bgcolor' ) }, 400);
			setTimeout(function(){ jQuery( '.circle .st4' ).addClass( 'bgcolor' ) }, 600);
			setTimeout(function(){ jQuery( '.circle .st5' ).addClass( 'bgcolor' ) }, 800);
			setTimeout(function(){ jQuery( '.circle .st6' ).addClass( 'bgcolor' ) }, 1000);
			setTimeout(function(){ jQuery( '.circle .st7' ).addClass( 'bgcolor' ) }, 1200);
			setTimeout(function(){ jQuery( '.st9' ).fadeIn(); }, 1400);
			setTimeout(function(){ jQuery( '.st4_letters' ).fadeIn(); }, 1400);
			
			// div_grafico.addEventListener('mouseover', function() {
			// 	setTimeout(function(){ jQuery( '.circle .st2' ).addClass( 'bgcolor' ) }, 200);
			// 	setTimeout(function(){ jQuery( '.circle .st3' ).addClass( 'bgcolor' ) }, 400);
			// 	setTimeout(function(){ jQuery( '.circle .st4' ).addClass( 'bgcolor' ) }, 600);
			// 	setTimeout(function(){ jQuery( '.circle .st5' ).addClass( 'bgcolor' ) }, 800);
			// 	setTimeout(function(){ jQuery( '.circle .st6' ).addClass( 'bgcolor' ) }, 1000);
			// 	setTimeout(function(){ jQuery( '.circle .st7' ).addClass( 'bgcolor' ) }, 1200);
			// 	setTimeout(function(){ jQuery( '.st9' ).fadeIn(); }, 1400);
			// });
			// 
			// if ( jQuery( window ).width() < 768 ) { 
			// 	setTimeout(function(){ jQuery( '.circle .st2' ).addClass( 'bgcolor' ) }, 200);
			// 	setTimeout(function(){ jQuery( '.circle .st3' ).addClass( 'bgcolor' ) }, 600);
			// 	setTimeout(function(){ jQuery( '.circle .st4' ).addClass( 'bgcolor' ) }, 800);
			// 	setTimeout(function(){ jQuery( '.circle .st5' ).addClass( 'bgcolor' ) }, 1000);
			// 	setTimeout(function(){ jQuery( '.circle .st6' ).addClass( 'bgcolor' ) }, 1200);
			// 	setTimeout(function(){ jQuery( '.circle .st7' ).addClass( 'bgcolor' ) }, 1400);
			// } else {
			// 	// Adicionar um evento de scroll à janela
			// 	window.addEventListener('scroll', function() {
			// 		// Obter a posição da div na página
			// 		const divTop = div_grafico.getBoundingClientRect().top;
			// 		const divBottom = div_grafico.getBoundingClientRect().bottom;
			// 		
			// 		// Obter a posição do elemento na página
			// 		const elementoTop = div_grafico.getBoundingClientRect().top;
			// 		const elementoBottom = div_grafico.getBoundingClientRect().bottom;
			// 	
			// 		// Obter a posição do scroll da página
			// 		const scrollPosition = window.innerHeight / 2 + window.scrollY;
			// 		const windowHeight = window.innerHeight;
			// 	
			// 		// Verificar se a div está no meio da tela
			// 		if (divTop <= scrollPosition && divBottom >= scrollPosition && divTop >= window.innerHeight / 2) {
			// 			setTimeout(function(){ jQuery( '.circle .st2' ).addClass( 'bgcolor' ) }, 200);
			// 			setTimeout(function(){ jQuery( '.circle .st3' ).addClass( 'bgcolor' ) }, 400);
			// 			setTimeout(function(){ jQuery( '.circle .st4' ).addClass( 'bgcolor' ) }, 600);
			// 			setTimeout(function(){ jQuery( '.circle .st5' ).addClass( 'bgcolor' ) }, 800);
			// 			setTimeout(function(){ jQuery( '.circle .st6' ).addClass( 'bgcolor' ) }, 1000);
			// 			setTimeout(function(){ jQuery( '.circle .st7' ).addClass( 'bgcolor' ) }, 1200);
			// 		}
			// 	
			// 	});
			// }
			
			// Talent Acquisiton Solution
			const tas = document.querySelector( '.grafico_desktop-big .st3_letters' );
			const tas_wrapper = document.querySelector( '.grafico_desktop-big .st3' );
			const tas_title = jQuery( '.grafico_desktop-big .st3' ).data( 'title' );
			const tas_content = jQuery( '.grafico_desktop-big .st3' ).data( 'content' );
			const tas_url = jQuery( '.grafico_desktop-big .st3' ).data( 'url' );
			
			tas.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st3' ).addClass( 'hover' );
			});
			
			tas_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st3' ).removeClass( 'hover' );
			});
			
			tas.addEventListener("click", function() {
				circle_modal( tas_title, tas_content, tas_url );
			});
			
			tas_wrapper.addEventListener("click", function() {
				circle_modal( tas_title, tas_content, tas_url );
			});
			
			// Bridge
			const bridge = document.querySelector( '.grafico_desktop-big .st4_letters' );
			const bridge_wrapper = document.querySelector( '.grafico_desktop-big .st4' );
			const bridge_title = jQuery( '.grafico_desktop-big .st4' ).data( 'title' );
			const bridge_content = jQuery( '.grafico_desktop-big .st4' ).data( 'content' );
			const bridge_url = jQuery( '.grafico_desktop-big .st4' ).data( 'url' );
			
			bridge.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st4' ).addClass( 'hover' );
			});
			
			bridge_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st4' ).removeClass( 'hover' );
			});
			
			bridge.addEventListener("click", function() {
				circle_modal( bridge_title, bridge_content, bridge_url );
			});
			
			bridge_wrapper.addEventListener("click", function() {
				circle_modal( bridge_title, bridge_content, bridge_url );
			});
			
			// HR Tech Solutions
			const hrts = document.querySelector( '.grafico_desktop-big .st5_letters' );
			const hrts_wrapper = document.querySelector( '.grafico_desktop-big .st5' );
			const hrts_title = jQuery( '.grafico_desktop-big .st5' ).data( 'title' );
			const hrts_content = jQuery( '.grafico_desktop-big .st5' ).data( 'content' );
			const hrts_url = jQuery( '.grafico_desktop-big .st5' ).data( 'url' );
			
			hrts.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st5' ).addClass( 'hover' );
			});
			
			hrts_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st5' ).removeClass( 'hover' );
			});
			
			hrts.addEventListener("click", function() {
				circle_modal( hrts_title, hrts_content, hrts_url );
			});
			
			hrts_wrapper.addEventListener("click", function() {
				circle_modal( hrts_title, hrts_content, hrts_url );
			});
			
			// Human Dev.
			const hd = document.querySelector( '.grafico_desktop-big .st6_letters' );
			const hd_wrapper = document.querySelector( '.grafico_desktop-big .st6' );
			const hd_title = jQuery( '.grafico_desktop-big .st6' ).data( 'title' );
			const hd_content = jQuery( '.grafico_desktop-big .st6' ).data( 'content' );
			const hd_url = jQuery( '.grafico_desktop-big .st6' ).data( 'url' );
			
			hd.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st6' ).addClass( 'hover' );
			});
			
			hd_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st6' ).removeClass( 'hover' );
			});
			
			hd.addEventListener("click", function() {
				circle_modal( hd_title, hd_content, hd_url );
			});
			
			hd_wrapper.addEventListener("click", function() {
				circle_modal( hd_title, hd_content, hd_url );
			});
			
			// Consulting
			const consulting = document.querySelector( '.grafico_desktop-big .st7_letters' );
			const consulting_wrapper = document.querySelector( '.grafico_desktop-big .st7' );
			const consulting_title = jQuery( '.grafico_desktop-big .st7' ).data( 'title' );
			const consulting_content = jQuery( '.grafico_desktop-big .st7' ).data( 'content' );
			const consulting_url = jQuery( '.grafico_desktop-big .st7' ).data( 'url' );
			
			consulting.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st7' ).addClass( 'hover' );
			});
			
			consulting_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st7' ).removeClass( 'hover' );
			});
			
			consulting.addEventListener("click", function() {
				circle_modal( consulting_title, consulting_content, consulting_url );
			});
			
			consulting_wrapper.addEventListener("click", function() {
				circle_modal( consulting_title, consulting_content, consulting_url );
			});
			
			// synchro
			const synchro = document.querySelector( '.grafico_desktop-big .st2_letters' );
			const synchro_wrapper = document.querySelector( '.grafico_desktop-big .st2' );
			const synchro_title = jQuery( '.grafico_desktop-big .st2' ).data( 'title' );
			const synchro_content = jQuery( '.grafico_desktop-big .st2' ).data( 'content' );
			const synchro_url = jQuery( '.grafico_desktop-big .st2' ).data( 'url' );
			
			synchro.addEventListener('mouseover', function() {
				jQuery( '.grafico_desktop-big .st2' ).addClass( 'hover' );
			});
			
			synchro_wrapper.addEventListener('mouseout', function() {
				jQuery( '.grafico_desktop-big .st2' ).removeClass( 'hover' );
			});
			
			synchro.addEventListener("click", function() {
				circle_modal( synchro_title, synchro_content, synchro_url );
			});
			
			synchro_wrapper.addEventListener("click", function() {
				circle_modal( synchro_title, synchro_content, synchro_url );
			});
			
			const circle_modal = function( title, content, url ) {
				const window_comp = window.innerWidth;
				div_grafico.style.pointerEvents = 'none';
				translate_x_circle( div_grafico );
				jQuery( '.content_grafico .body_cg' ).find( 'h1' ).text( title );
				jQuery( '.content_grafico .body_cg' ).find( 'p' ).text( content );
				jQuery( '.content_grafico .body_cg' ).find( 'button').attr( 'onclick', 'window.open("' + url + '", "_blank");');
				
				if ( window_comp < 770 ){
					setTimeout(function(){ jQuery( '.content_grafico' ).fadeIn() }, 500);
					setTimeout(function(){
						padding_left_modal();
						div_grafico.style.pointerEvents = 'auto';
					}, 500);
				} else {
					console.log('here');
					setTimeout(function(){ jQuery( '.content_grafico' ).fadeIn() }, 2000);
					setTimeout(function(){
						padding_left_modal();
						div_grafico.style.pointerEvents = 'auto';
					}, 2000);
				}
			}
			
			const close_cg = document.querySelector( '.content_grafico .close_cg' );
			close_cg.addEventListener("click", function() {
				div_grafico.style.transform = 'translateX(0)';
				jQuery( '.content_grafico' ).hide();
			});
			
			window.addEventListener('resize', function(event) {
				padding_left_modal();
			});
			
			const padding_left_modal = function( title, content) {
				const tamanho_row = jQuery( '.background_color-green' ).width();
				const tamanho_left = tamanho_row * 0.40;

				if ( tamanho_left < 864 && tamanho_left > 780) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left );
				} else if ( tamanho_left < 780 && tamanho_left > 656 ) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left + 135 );
				} else if ( tamanho_left < 656 && tamanho_left > 581  ) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left + 135 );
				} else if ( tamanho_left < 581 && tamanho_left > 488 ) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left + 70 );
				} else if ( tamanho_left < 488 && tamanho_left > 443 ) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left + 90);
				} else if ( tamanho_left < 443 ) {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', '0' );
				} else {
					jQuery( '.content_grafico_wrapper' ).css( 'padding-left', tamanho_left + 160 );
				}
			}
			
			const translate_x_circle = function( div_grafico ) {
				const window_comp = window.innerWidth;
				if ( window_comp < 1470 && window_comp > 820 ) {
					div_grafico.style.transform = 'translateX(-50%)';
				} else if ( window_comp <= 820 ){
					div_grafico.style.transform = 'translateX(0)';
				} else {
					div_grafico.style.transform = 'translateX(-45%)';
				}
			}
			
		}
		
	});
} )();